import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { XAxisButton } from '@/common/dashboard/XAxisButton';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useForm } from '@/common/form/FormContext';
import { useNavState } from '@/common/navState/NavStateContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useMemo } from 'react';

export const IndirSaleTrendCard = ({ xAxisOptions, metricOptions }) => {
  const { formValues } = useForm();
  const { navigateTo } = useNavState();

  const reqParam = useMemo(
    () => ({
      metric: formValues.metric,
      prodExpr: formValues.prodExpr,
      ctrtExpr: formValues.ctrtExpr,
      distCustExpr: formValues.distCustExpr,
      shipCustExpr: formValues.shipCustExpr,
      rcvdPeriodExpr: formValues.rcvdPeriodExpr,
      invPeriodExpr: formValues.invPeriodExpr,
      xAxis: formValues.xAxis,
    }),
    [
      formValues.metric,
      formValues.prodExpr,
      formValues.ctrtExpr,
      formValues.distCustExpr,
      formValues.shipCustExpr,
      formValues.rcvdPeriodExpr,
      formValues.invPeriodExpr,
      formValues.xAxis,
    ],
  );

  const navigateToIndirSaleLineList = (data, point) => {
    const id = data.ids[point.x];
    const navState = {
      mode: Mode.LIST,
      expr: ExprUtils.and(ExprUtils.whereParams(data.drillField, id), data.filterExpr),
    };

    navigateTo('sc/indir-sale-line', navState);
  };

  const metric =
    metricOptions
      .filter((option) => formValues.metric?.includes(option.value))
      .map((option) => option.displayName)
      .join(' & ') || metricOptions[0].displayName;
  const xAxisLabel = xAxisOptions.find((option) => option.code === formValues.xAxis)?.displayName;
  return (
    <DashboardCard
      title={metric + ' by ' + xAxisLabel}
      description={'Displays the Indirect Sale Lines ' + metric + ' by ' + xAxisLabel}
      module="sc"
      plugin="INDIR_SALE_TREND_DATA_PLUGIN"
      reqParam={reqParam}
      buttons={<XAxisButton options={xAxisOptions} />}
    >
      {(data) => (
        <CartesianChart
          rotateXLabels={false}
          onClick={(point) => navigateToIndirSaleLineList(data, point)}
          data={data}
          legend="top"
          yLabel={'Amount in $'}
          allowNegative
        />
      )}
    </DashboardCard>
  );
};
